/* eslint-disable react/prop-types */
import { UpsellBaseModal } from '../UpsellBaseModal'
import { FeedbackButtonGrid } from '../FeedbackButtonGrid'
import styles from './styles.module.css'

const CheckIcon = () => (
  <svg width="50" height="50" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 12.5L9.5 17L19 7"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CheckIconModal = ({
  isOpen,
  onClose,
  title,
  titleId = 'check-icon-modal-title',
  description,
  feedback,
  primaryAction,
  secondaryAction,
  showCloseButton = true,
  showCheckIcon = true,
}) => {
  const hasActions = primaryAction || secondaryAction

  return (
    <UpsellBaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      titleId={titleId}
      titleClassName={styles.modalTitle}
      headerClassName={styles.modalHeader}
      showCloseButton={showCloseButton}
      contentClassName={styles.modalContent}
      headerIcon={
        showCheckIcon ? (
          <span className={styles.checkIcon}>
            <CheckIcon />
          </span>
        ) : null
      }
    >
      <div className={styles.bodyContent}>
        {description && <p className={styles.description}>{description}</p>}

        {(feedback?.question || feedback?.options?.length > 0) && (
          <div className={styles.surveySection}>
            {feedback?.question && (
              <p className={styles.surveyQuestion}>{feedback.question}</p>
            )}

            {feedback?.options?.length > 0 && (
              <FeedbackButtonGrid
                options={feedback.options}
                onSelect={feedback.onSelect}
                selectedId={feedback.selectedId}
                columns={feedback.columns}
              />
            )}
          </div>
        )}

        {hasActions && (
          <div className={styles.actions}>
            {primaryAction && (
              <button
                type="button"
                className={styles.primaryButton}
                onClick={primaryAction.onClick}
                disabled={primaryAction.disabled}
              >
                {primaryAction.label}
              </button>
            )}

            {secondaryAction && (
              <button
                type="button"
                className={styles.outlineButton}
                onClick={secondaryAction.onClick}
                disabled={secondaryAction.disabled}
              >
                {secondaryAction.label}
              </button>
            )}
          </div>
        )}
      </div>
    </UpsellBaseModal>
  )
}

export default CheckIconModal
